import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextInput, { isValidText } from './TextInput';
import SelectInput from './SelectInput';
import GiroInput, { isValidGiro } from './GiroInput';
import { ClearingInput, BankAccountNumberInput, checkBankAccount } from './BankAccountInput';
import { Reimbursee } from './Types';
import { apiCreateReimbursee } from './Api';
import { addToCallChain } from './CallCenter';

type Route = 'bank' | 'giro'
const ROUTES: { value: Route, name: string }[] = [
  { value: 'bank', name: 'Bankkonto' },
  { value: 'giro', name: 'Bankgiro eller plusgiro' },
]

// The reimbursee counterpart to SupplierCreationDialog: someone a kvitto på utlägg is paid to —
// usually a private person by domestic bank account (clearing + account number), but a company or
// association can be paid by bankgiro or plusgiro instead. Reuses the supplier dialog's overlay/CSS.
function ReimburseeCreationDialog({onCreate, onCancel}: {
  onCreate: (args: {newReimbursees: Reimbursee[], newReimburseeId: string}) => void,
  onCancel: () => void
}) {

  const [name, setName] = useState('')
  const [route, setRoute] = useState<Route>('bank')
  const [clearing, setClearing] = useState('')
  const [account, setAccount] = useState('')
  const [giro, setGiro] = useState('')

  function createReimbursee() {
    const data = route === 'bank'
      ? {name: name, clearing_number: clearing, bank_account_number: account, giro_number: null}
      : {name: name, clearing_number: null, bank_account_number: null, giro_number: giro}
    addToCallChain(
      async () => {
        const responseData = await apiCreateReimbursee(data)
        onCreate({newReimbursees: responseData.reimbursees, newReimburseeId: responseData.new_reimbursee_id})
      },
      true
    )
  }

  // Bank-aware validation over both fields together: the account's rules depend on the clearing
  // number's bank. Only shown once both have content, so an untouched form doesn't nag.
  const check = checkBankAccount(clearing, account)
  const showStatus = clearing.trim() !== '' && account.trim() !== ''
  const isValid = isValidText(name) && (route === 'bank' ? check.ok : isValidGiro(giro))

  return (
    <>
    <div id="div-recognize-overlay"></div>
    <div id="div-new-supplier">
      <TextInput id="new-reimbursee-name" label="Namn" inputProps={{'maxLength': "50"}} value={name} onChange={setName}/>
      <SelectInput label="Betalas till" required={true} options={ROUTES} valueGetter={r => r.value}
        nameGetter={r => r.name} value={route} onChange={setRoute}/>
      {route === 'bank' ? <>
        <ClearingInput id="new-reimbursee-clearing" label="Clearingnummer" value={clearing} onChange={setClearing}/>
        <BankAccountNumberInput id="new-reimbursee-account" label="Kontonummer" value={account} onChange={setAccount}/>
        {showStatus &&
          <div style={{ fontSize: '0.8rem', color: check.ok ? '#2e7d32' : '#c62828' }}>
            {check.ok ? `✓ ${check.bank}` : check.reason}
          </div>}
      </> : <GiroInput id="new-reimbursee-giro" label="Bank-/plusgiro" value={giro} onChange={setGiro}/>}
      <div className="buttons">
          <Button variant="contained" disabled={!isValid} id="button-submit-create-reimbursee" onClick={createReimbursee}>Skapa mottagare</Button>
          <Button variant="text" id="button-cancel-popup" onClick={onCancel}>Avbryt</Button>
      </div>
    </div>
    </>
  )
}

export default ReimburseeCreationDialog
